// Shared prop/type shapes for the /assets filter bar (desktop) and the
// mobile filter sheet. Kept local to this route — FilterBar/useUrlFilters
// have exactly one caller today (this route); Select/FilterChip/ToggleChip,
// which DO have (or are expected to soon have) multiple callers, live in
// packages/shared/src/ui instead. See plans/filter-standardization-spec.md §5.

export interface FilterOption {
  value: string;
  label: string;
}

/** Structural shape satisfied by LocationOption/LotOption/Team below. */
export interface NamedOption {
  id: string;
  name: string;
}

export interface ActiveChip {
  key: string;
  label: string;
  value: string;
  onRemove: () => void;
}

export interface FilterBarProps {
  searchDraft: string;
  setSearchDraft: (v: string) => void;
  lifecycleFilter: string;
  setLifecycleFilter: (v: string) => void;
  conditionFilter: string;
  setConditionFilter: (v: string) => void;
  manufacturerFilter: string;
  setManufacturerFilter: (v: string) => void;
  modelDraft: string;
  setModelDraft: (v: string) => void;
  locationFilter: string;
  setLocationFilter: (v: string) => void;
  lotFilter: string;
  setLotFilter: (v: string) => void;
  teamFilter: string;
  setTeamFilter: (v: string) => void;
  missingFinancialsOnly: boolean;
  setMissingFinancialsOnly: (v: boolean) => void;

  lifecycleOptions: FilterOption[];
  conditionOptions: FilterOption[];
  manufacturerOptions: string[];
  locations: NamedOption[] | undefined;
  lots: NamedOption[] | undefined;
  teams: NamedOption[] | undefined;
  isAdmin: boolean;

  resultCount: number;
  isFetching: boolean;
  activeChips: ActiveChip[];
  onClearAll: () => void;
}

/** True if any secondary (disclosure-tier) filter is currently active —
 *  used to auto-expand "More filters" on load for a bookmarked link. */
export function hasSecondaryActive(p: {
  modelDraft: string;
  locationFilter: string;
  lotFilter: string;
  teamFilter: string;
}): boolean {
  return Boolean(p.modelDraft || p.locationFilter || p.lotFilter || p.teamFilter);
}
